(function($) {
    $(document).on('ready', function() {

        window.page = new Page();

    });

    // ------------------------------------------------------------------------------------------------------
    // COMMON PAGE FUNCIONALITY

    Page = function()
    {
        // Form validation
        this.initValidation();

        if ($('#password-viewer').length) {
            var preview = new PreviewPassword('form_email', 'password-viewer');
        }

        $('[data-toggle="tooltip"]').tooltip();

        //Equal height groups
        var heightGroups = new EqualHeightGroups();

        //DataCopier
        DataCopier.init();

        if($('.quote').length){
            $(document).on('click',"[data-action='select-room']", ConfirmBox);
            $(document).on('click',"[data-action='close-confirmation']", function(e){
                $(e.currentTarget).parents('.confirmation').eq(0).fadeOut();
            });
        }

        if($('.enquiry-edit').length){
            formInputActions();
        }

        if($('.messaging').length){
            var messaging = new MessagingAnimation();
        }

        $(document).on('keyup',"[data-action='filter-enquiries']",EnquiryListSearch);

        var $from;
        var $to;

        if($('.datepicker').length){
            $('.datepicker').each(function(i,el){
                var date  = $(el).attr('data-date');
                var d = new Date(0); // The 0 there is the key, which sets the date to the epoch
                d.setUTCSeconds(date);

                if($(el).is("#from")) {
                    if(date)
                    {
                        $from = $(el).datetimepicker(
                            {
                                minDate: moment(),
                                format: "DD, dddd MMMM, YYYY"
                            }
                        );
                        $from.data("DateTimePicker").date(moment(d));
                        $('#from-posted').val(moment(d).format("YYYY-MM-DD 12:00:00"));
                    }
                    else {
                        $from = $(el).datetimepicker(
                            {
                                minDate: moment(),
                                format: "DD, dddd MMMM, YYYY"
                            }
                        );
                        $from.data("DateTimePicker").date(moment());
                        $('#from-posted').val(moment().format("YYYY-MM-DD 12:00:00"));
                    }
                }
                if($(el).is("#to")) {
                    if(date)
                    {
                        $to = $(el).datetimepicker(
                            {
                                minDate: moment().add(1, 'days'),
                                format: "DD, dddd MMMM, YYYY"
                            }
                        )
                        $to.data("DateTimePicker").date(moment(d));
                        $('#to-posted').val(moment(d).format("YYYY-MM-DD 12:00:00"));
                    }
                    else {
                        $to = $(el).datetimepicker(
                            {
                                minDate: moment().add(1, 'days'),
                                format: "DD, dddd MMMM, YYYY"
                            }
                        );
                        $to.data("DateTimePicker").date(moment().add(1, 'days'));
                        $('#to-posted').val(moment().add(1, 'days').format("YYYY-MM-DD 12:00:00"));
                    }
                }
            });
            $from.on("dp.change", function (e) {
                $('#from-posted').val(e.date.format("YYYY-MM-DD 12:00:00"));
                $to.data("DateTimePicker").minDate(e.date.add(1, 'days'));
            });

            $to.on("dp.change", function (e) {
                $('#to-posted').val(e.date.format("YYYY-MM-DD 12:00:00"));
            });
        }

        if($('.timepicker').length) {
            $('.timepicker').datetimepicker({
                format: 'LT'
            });
        }

        $("[data-action='open-nudge-form']").magnificPopup({type:'inline',preloader:false,
            callbacks:{afterClose: function() {
                $('#nudge-form').children('.btn').show();
                $('#nudge-form').children('.response').html('');
                $('#nudge-form').attr('data-attribute-id','');
            }}});

        $(document).on('click',"[data-action='open-nudge-form']",function(e){
            $this = $(e.currentTarget);
            $('#nudge-form').attr('data-attribute-id',$this.attr('data-attribute-id'));
        });

        $("[data-action='open-visit-form']").magnificPopup({type:'inline',preloader:false,
            callbacks:{afterClose: function() {
                $('#visit-form').children('.btn').show();
                $('#visit-form').find('h2 span').html('');
                $('#visit-form').attr('data-attribute-id','');
                $('#visit-form').children('.response').html('');
                $('#visit-form').children('.btn').html('Request Visit');
                $('#visit-form').find('input').val('');
            }}});

        $(document).on('click',"[data-action='open-visit-form']",function(e){
            $this = $(e.currentTarget);
            $('#visit-form').find('h2 span').html($this.attr('data-attribute-name'))
            $('#visit-form').attr('data-attribute-id',$this.attr('data-attribute-id'));
            $('#visit-form').children('.btn').prop('disabled',false);
        });

        $(document).on('click',"[data-action='nudge']",function(e){
            $container = $(e.currentTarget).parents('#nudge-form').eq(0);
            var quote_id = $('#nudge-form').attr('data-attribute-id');
            var token = $('#ajax_token').val();
            $.post( "/quotes/"+quote_id+"/nudge", { _token:token})
                .done(function( resp ) {
                    if(resp){
                        $('#nudge-form').children('.btn').fadeOut(function(){
                            $('#nudge-form').children('.response').html('Nudge Sent');
                        });
                    }else{
                        $('#nudge-form').children('.btn').fadeOut(function(){
                            $('#nudge-form').children('.response').html('Nudge Fail');
                        });
                    }
                })
                .fail(function(){
                    $('#nudge-form').children('.btn').fadeOut(function(){
                        $('#nudge-form').children('.response').html('Nudge Fail');
                    });
                });
        });

        $(document).on('click',"[data-action='request-visit']",function(e){
            $container = $(e.currentTarget).parents('#visit-form').eq(0);
            var appartment_id = $('#visit-form').attr('data-attribute-id');
            var date = $('#visit-form').find('#visit-date').val();
            var time = $('#visit-form').find('#visit-time').val();
            var guest = $('#visit-form').find('#guest-liaison').val();
            var number = $('#visit-form').find('#guest-number').val();
            var token = $('#ajax_token').val();

            $.post( "/apartments/"+appartment_id+"/visit", {date:date,time:time,guest:guest,number:number, _token:token},function(){
                $('#visit-form').children('.btn').prop('disabled',true);
                $('#visit-form').children('.btn').html('Sending');
            })
                .done(function( resp ) {
                    if(resp){
                        $('#visit-form').children('.btn').fadeOut(function(){
                            $('#visit-form').children('.response').html('Request Sent');
                        });
                    }else{
                        $('#visit-form').children('.btn').fadeOut(function(){
                            $('#visit-form').children('.response').html('Request Fail');
                        });
                    }
                })
                .fail(function(){
                    $('#nudge-form').children('.btn').fadeOut(function(){
                        $('#nudge-form').children('.response').html('Request Fail');
                    });
                });
        });

        $(document).on('change',"[data-action='change-to-for']",function(e){
            $this = $(e.currentTarget);
            changeToFor($this.val());
        });
        changeToFor($('#change-to-for').val());

        $(document).on('change',"[data-action='toggle-prices']",function(){
            $('.price').toggleClass('hide');
        });

        if($("#requested_building").length) {
            var myareasBloodHound = new Bloodhound({
                local: buildingsArray,
                identify: function (obj) {
                    return obj.id;
                },
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                datumTokenizer: function (d) {
                    return Bloodhound.tokenizers.whitespace(d.name);
                }
            });

            myareasBloodHound.initialize();

            var typeahead = $("#requested_building").typeahead({
                    highlight: true
                },
                {
                    name: 'my-dataset',
                    source: myareasBloodHound,
                    display: 'name',
                    templates: {
                        notFound: '<div class="tt-suggestion">No Match Found ...</div>'
                    }
                });
            typeahead.bind('typeahead:select', function (e, suggestion) {
                $('#requested_building_id').val(suggestion.id);
            });
            typeahead.bind('typeahead:autocomplete', function (e, suggestion) {
                $('#requested_building_id').val(suggestion.id);
            });
            typeahead.bind('typeahead:render', function (e, suggestion) {
                if (typeof suggestion != 'undefined' && $(e.currentTarget).val() == suggestion.name) {
                    $('#requested_building_id').val(suggestion.id);
                } else {
                    $('#requested_building_id').val("");
                }

            });
        }

        //Quote email handler
        var quoteEmail = new QuoteEmail()

        $(document).on('click',"[data-action='open-cancellation-policy']",function(e){
            $container = $(e.currentTarget).parents('.item').eq(0);
            $.magnificPopup.open({
                items:{
                    src: $container.find('.cancellation-policy'),
                    type: 'inline'
                }
            });
        });

        $(document).on('click',"[data-action='toggle-user-details']",function(e){
            $container = $(e.currentTarget).parents('.form-section').eq(0);
            if($container.hasClass('collapsed')){

                $('#firstname').val("").change();
                $('#lastname').val("").change();
                $('#landline').val("").change();
                $('#email').val("").change();
                $(e.currentTarget).html("Use My Details");

                $container.removeClass('collapsed');
            }else{
                $(e.currentTarget).html("Enter Customer Details");
                $('#title').val("").change();
                $('#firstname').val(userDetails.firstname).change();
                $('#lastname').val(userDetails.lastname).change();
                $('#landline').val(userDetails.phone).change();
                $('#mobile').val("").change();
                $('#email').val(userDetails.email).change();

                $container.addClass('collapsed');
            }
            return false;
        });

        $(document).on('click',"[data-action='toggle-extended-address']",function(e){
            if($(this).html() == 'Use Exact Address'){
                $('.extended-adress').fadeIn();
                $(this).html('Use town name only');
            }else{
                $('.extended-adress').find('input').val('');
                $('.extended-adress').fadeOut();
                $(this).html('Use Exact Address');
            }
            return false;
        });

        if($('#place-autocomplete').length) {
            var input = document.getElementById('place-autocomplete');
            var autocomplete = new google.maps.places.Autocomplete(input);

            autocomplete.addListener('place_changed', function() {
                $(input).change();
                var place = autocomplete.getPlace();
                if (place.geometry.location)
                {
                    $("#lat").val(place.geometry.location.lat());
                    $("#lng").val(place.geometry.location.lng());
                }
            });
        }

        $(document).on('click',"[data-action='delete-quote']",function(el){
            $el = $(el.currentTarget);
            var token = $('#_token').val();
            $.magnificPopup.open({
                items: {
                    src: '<form method="post" data-action="submit-delete" action="'+$el.attr('href')+'" class="white-popup"><input type="hidden" name="_token" value="'+token+'"><h3>Please let us know why you\'re deleting this Enquiry</h3> <textarea class="form-control" name="reason" id="delete-reason"></textarea><p class="popup-warning"></p><button class="btn btn-sc primary-btn" type="submit">Delete</button></form>', // can be a HTML string, jQuery object, or CSS selector
                    type: 'inline'
                }
            });
            return false;
        });

        $(document).on('submit',"[data-action='submit-delete']",function(el){
            if(!$("#delete-reason").val().length)
            {
                $("#delete-reason").parents('form').eq(0).find('.popup-warning').html('Please enter a reason').fadeIn();
                return false
            }
        });

        var submitable = false;
        $(document).on('submit','[data-action="block-form"]',function(){
            var popup = $(this).data('popup');
            if(!submitable) {
                $.magnificPopup.open({
                    items: {
                        src: popup,
                        type: 'inline',
                        //closeBtnInside:false
                    }
                });
                return false;
            }
        });
        $(document).on('click','[data-action="submit-blocked-form"]',function(){
            submitable = true;
            $($(this).data('form')).submit();
            submitable = false;
            return false;
        });

        $(document).on('click','[data-action="close-popup"]',function(){
            $.magnificPopup.close();
            return false;
        });


        $(document).on('click', '[data-action="forgot-password"]', function (event) {

            const forgotPasswordForm = $('.forgotten-password-form');

            forgotPasswordForm.fadeIn("slow", function () {

                forgotPasswordForm.find('#username').focus();

            });
        });

    };

    function addZero(i) {
        if (i < 10) {
            i = "0" + i;
        }
        return i;
    }

    /**
     * Form Validation using Parsley JS: http://parsleyjs.org/doc/index.html
     */
    Page.prototype.initValidation = function()
    {
        if (!$('form.validate').length) { return; }

        // Validate all forms with the "validate" class
        $('form.validate').parsley({
            trigger: 'change', // Which event to trigger validation on
            errorClass: 'has-error', // Class when there are errors
            successClass: 'has-success', // Class for successful validation
            errorsMessagesDisabled: true, // Whether to add disable messages on each field
            trimValue: true, // Trim whitespace before validation
            validationThreshold: 3, // Minimum number of chars before validation will fire

            classHandler: function(field)
            {
                var tagName = (field.$element.prop('tagName') || '').toLowerCase();
                var type = (field.$element.attr('type') || '').toLowerCase();

                // Add feedback class and icons
                if (type != 'radio' && type != 'checkbox' && tagName != 'textarea') {
                    field.$element.after(
                        '<i class="fa fa-check form-control-feedback feedback-success" aria-hidden="true"></i>' +
                        '<i class="fa fa-remove form-control-feedback feedback-error" aria-hidden="true"></i>'
                    );
                    field.$element.parents('.form-group').eq(0).addClass('has-feedback');
                }

                return field.$element.parents('.form-group').eq(0);
            },

            errorsContainer: function (field)
            {
                return field.$element.parents('.form-group').eq(0);
            }

        });
    }

    // ------------------------------------------------------------------------------------------------------
    // Messaging Animation

    MessagingAnimation = function(messagingContainer)
    {
        $(document).on('click','.messaging [data-action="toggle-important"]', $.proxy(this.showHideImportant, this));
        $(document).on('click','.messaging [data-action="toggle-messenger"]', $.proxy(this.showHideMessenger, this));
        $(document).on('click','.messaging .messenger [data-action="toggle-trivial"]', $.proxy(this.toggleTrivial, this));
        $(document).on('click','.messaging .messenger [data-action="pick-important"]', $.proxy(this.pickImportant, this));
        $(document).on('click','.messaging .messenger [data-action="post"]', $.proxy(this.postMessage, this));
        $(document).on('click','.messaging .messenger [data-action="edit"]', $.proxy(this.editMessage, this));
        $('.messenger').draggable({
            containment: "document",
            handle:'.messenger-header'
        }).resizable({
            handles: 's',
            resize: this.resizeMessageBox
        });


    }

    MessagingAnimation.prototype.showHideImportant = function(e){
        var $container = $(e.currentTarget).parents('.messaging').eq(0);
        $container.find('.important-messages').toggleClass('important-close');
        if($container.find('.important-messages').hasClass('important-close'))
            $container.find('[data-action="toggle-important"]').html('Show');
        else
            $container.find('[data-action="toggle-important"]').html('Hide');
    }

    MessagingAnimation.prototype.showHideMessenger = function(e){
        var $container = $(e.currentTarget).parents('.messaging').eq(0);

        var quoteId = $container.attr('data-quote-id');
        $.get('/messages/read/'+quoteId);

        $container.find('.messenger').toggleClass('messenger-close');
        setTimeout($.proxy(function(){
            $(window).trigger('resize');
            $textarea = $container.find('.messenger-input textarea');
            $unreadMessages = $container.find('.unread-messages');
            $unreadMessages.fadeOut('slow');
            autosize($textarea);
            this.resizeMessageBox($container.find('.messenger'));
            $textarea.on('autosize:resized',$.proxy(function(e){
                this.resizeMessageBox($container.find('.messenger'));
            },this));
            $container.find('.messenger').find('ul').animate({ scrollTop: $container.find('.messenger').find('ul').prop("scrollHeight")}, 1000);
        },this),301);
    }

    MessagingAnimation.prototype.pickImportant = function(e){
        var $messageContainer = $(e.currentTarget).parents('li').eq(0);
        var $globalContainer = $messageContainer.parents('.messaging').eq(0);

        var data = {};
        data['token'] = $('#ajax_token').val();
        data['messageId'] = $messageContainer.attr('data-message-id');
        data['isImportant'] = true;
        if($messageContainer.hasClass('active-important'))
            data['isImportant'] = false;
        $.post( "/messages/"+data['messageId'], { postData:{isImportant: data['isImportant'] },_token:data['token']})
            .done($.proxy(function( resp ) {
                if(resp.ID){
                    if(resp.IsImportant) {
                        var newMessageDate = $messageContainer.find('.messaging-date').html();
                        var newImportant = "<li data-message-id='" + data['messageId'] + "'>" +
                            "<div class='messaging-author purple' data-height-group='messaging'>" + $messageContainer.find('.messaging-author').html() + "</div>" +
                            "<div class='messaging-message' data-height-group='messaging'><span class='messaging-date'>" + newMessageDate + "</span>" +
                            "<p>" + $messageContainer.find('p').html() + "</p> </div> </li>";
                        if (!$globalContainer.find(".important-messages ul li").length) {
                            $globalContainer.find(".messaging-header span").html("Important messages");
                            $globalContainer.find('[data-action="toggle-important"]').removeClass("hidden");
                            $globalContainer.find(".important-messages").removeClass("important-close");
                        }
                        $globalContainer.find(".important-messages ul").append(newImportant);
                        $globalContainer.find(".important-messages ul [data-message-id='" + data['messageId'] + "'] a").remove();
                        $globalContainer.find('.important-messages ul li').sort(this.sortList).appendTo('.important-messages ul');

                        $messageContainer.addClass('active-important');
                        $(window).resize();
                    }else {
                        $messageContainer.removeClass('active-important');
                        $globalContainer.find(".important-messages [data-message-id='" + data['messageId'] + "']").remove();
                        setTimeout($.proxy(function () {
                            if (!$globalContainer.find(".important-messages ul li").length) {
                                $globalContainer.find('[data-action="toggle-important"]').addClass("hidden");
                                $globalContainer.find(".important-messages").addClass("important-close");
                                $globalContainer.find(".messaging-header span").html("No important messages");
                            }
                        }, this));
                    }
                }else{
                    alert('Sorry , add / remove this message as important failed. Please try again later');
                }
            },this))
            .fail(function() {
                alert('Sorry , add / remove this message as important failed. Please try again later');
            });
    }

    MessagingAnimation.prototype.toggleTrivial = function(e){
        var $container = $(e.currentTarget).parents('.messenger').eq(0);
        $(e.currentTarget).toggleClass('active-trivial');
        $container.find('li:not(.active-important)').toggleClass('trivial-close');
    }

    MessagingAnimation.prototype.postMessage = function (e) {
        var $messagesContainer = $(e.currentTarget).parents('.messenger').eq(0);
        var $globalContainer = $messagesContainer.parents('.messaging').eq(0);

        var data = {};
        data['quoteId'] = $globalContainer.attr('data-quote-id');
        data['message'] = $messagesContainer.find('textarea').val();
        data['token'] = $('#ajax_token').val();
        var buttonPressed = $(e.currentTarget);
        buttonPressed.prop("disabled", true);
        $.post("/messages", { postData: { quote_id: data['quoteId'], message: data['message'] }, _token: data['token'] })
            .done(function (resp) {
                if (resp.ID) {
                    var color = 'purple';
                    if (resp.isRoomB)
                        color = 'blue';
                    var d = new Date(resp.Created * 1000);
                    var text = "<li class='row' data-message-id='" + resp.ID + "'><div class='messaging-author col-xs-6' data-height-group='messenger'>" +
                        "<span class='primary-color'>" + resp.Username + "</span></div><div class='messenger-message col-xs-18' data-height-group='messenger'>" +
                        "<span class='messaging-date'>Today <i class='gap'></i>" + addZero(d.getHours()) + ":" + addZero(d.getMinutes()) +
                        "<a href='javascript:void('Pick Important')' data-action='pick-important'><i class='fa fa-star-o primary-color'></i><i class='fa fa-star primary-color'></i>" +
                        "</a></span><p>" + nl2br(resp.Message) + "</p></div></li>";
                    $messagesContainer.find('ul').append(text);
                    $messagesContainer.find('textarea').val('');
                    $messagesContainer.find('ul').animate({ scrollTop: $messagesContainer.find('ul').prop("scrollHeight") }, 1000);
                    buttonPressed.prop("disabled", false);
                }
                else {
                    alert('Sorry something happened when creating your message');
                    buttonPressed.prop("disabled", false);
                }
            })
            .fail(function () {
                alert('Sorry something happened when creating your message');
                buttonPressed.prop("disabled", false);
            });
    }

    MessagingAnimation.prototype.editMessage = function(e){
        var $container = $(e.currentTarget).parents('.messaging').eq(0);
        var quoteId = $container.attr('data-quote-id')
    }

    MessagingAnimation.prototype.sortList = function(a, b){
        return +b.getAttribute('data-message-id') - +a.getAttribute('data-message-id');
    }

    MessagingAnimation.prototype.resizeMessageBox = function(e,ui){
        if($(e.target).length)
            var $container = $(e.target);
        else
            var $container = e;

        var containerHeight = $container.outerHeight();
        var textareaHeight = $container.children('.messenger-body').children('.messenger-input').outerHeight();
        var headerHeight = $container.children('.messenger-header').outerHeight();

        var bodyHeight = containerHeight - textareaHeight - headerHeight - 12;

        $container.children('.messenger-body').children('ul').css('max-height',bodyHeight);
        $container.find('.messenger-input button').outerHeight($container.find('.messenger-input textarea').outerHeight());
        /*setTimeout($.proxy(function(){
         this.getMaxHeight($container);
         },this));*/
    }

    MessagingAnimation.prototype.getMaxHeight = function($messenger){
        if(!$messenger.hasClass('messenger-close')) {
            var maxHeight = 60;
            maxHeight += $messenger.find('.messenger-header').outerHeight();
            $messenger.find('ul li').each(function () {
                maxHeight += $(this).outerHeight();
            })
            maxHeight += $messenger.find('.messenger-input').outerHeight();
            $messenger.css('maxHeight', maxHeight);
        }else{
            $messenger.css('maxHeight', 0);
        }
    }

    // ------------------------------------------------------------------------------------------------------
    // EQUAL HEIGHT GROUPS

    EqualHeightGroups = function(wrap, opts)
    {

        this.opts = $.extend({}, EqualHeightGroups.defaults, opts || {});
        this.wrap = wrap || $('body');



        $(window).on('load resize', $.proxy(this.onResize, this));
        this.onResize();
    }

    EqualHeightGroups.defaults = {};

    EqualHeightGroups.prototype.processGroup = function(groupId)
    {
        var group = this.groups[groupId].height('auto'),
            lines = {};

        group.each(function(i, el) {
            var cPos = $(el).offset().top+'';
            if (!lines.hasOwnProperty(cPos)) lines[cPos] = [];
            lines[cPos].push(el);
        });

        for (var p in lines) {
            var line = $(lines[p]).map(function() { return $(this).toArray(); } );
            var maxHeight = Math.max.apply(null, line.map(function() {
                return $(this).height();
            }).get());
            line.height(maxHeight);
        }
    }

    EqualHeightGroups.prototype.onResize = function()
    {
        if (!this.wrap.find('[data-height-group]').length) return;

        var groups = {};

        this.wrap.find('[data-height-group]').each(function() {

            var groupId = $(this).attr('data-height-group');

            if (groups.hasOwnProperty(groupId)) return;

            groups[groupId] = $('[data-height-group="'+groupId+'"]');

        });

        this.groups = groups;

        if (this.throttleResize == true) {
            this.resizeAttempts++;
            return;
        }

        for (var p in this.groups) {
            this.processGroup(p);
        }

        this.throttleResize = true;
        this.resizeAttempts = 0;
        clearTimeout(this.resizeTimeout || null);
        setTimeout($.proxy(function() {
            this.throttleResize = false;
            if (this.resizeAttempts > 0) {
                this.onResize();
            }
        }, this), 500);
    }

    ConfirmBox = function(e){
        $('.quote .item .confirmation').fadeOut();

        var $el = $(e.currentTarget);
        var $container= $el.parents('.item').eq(0);

        var roomId = $el.attr('data-confirmation-id');
        var roomName = $el.attr('data-room-name');


        $container.find('.confirmation .selected_apartment').val(roomId);
        $container.find('.confirmation .choice span').html(roomName);
        $container.find('.confirmation').fadeIn();
    }

    function formInputActions(){
        /*$('#children').on('change',function(){
         var element = "<div class='col-xs-2 children age-item'><input type='number' min='0' max='17' class='form-control less-pad' name='children_age[]' required></div>";
         var value = $(this).val();
         var numberOfElements = $('.age-item').length;
         if(value > 0){
         $('.children').fadeIn();
         while(numberOfElements > value){
         $('.age-item').last().remove();
         numberOfElements = $('.age-item').length;
         }
         while(numberOfElements < value){
         $('.age').append(element);
         $('.children').fadeIn();
         numberOfElements = $('.age-item').length;

         }
         }else{
         $('.children').fadeOut();
         }
         });*/
        $('#pets').on('change',function(){
            var value = $(this).val();
            if(value == 1){
                $('.pet-desc').fadeIn();
            }else{
                $('.pet-desc').fadeOut();
            }
        });
        $('#parking').on('change',function(){
            var value = $(this).val();
            if(value == 1){
                $('.parking-number').fadeIn();
            }else{
                $('.parking-number').fadeOut();
            }
        });



    }

    // ------------------------------------------------------------------------------------------------------
    // Enquiry list search

    EnquiryListSearch = function(e){
        var val = $(e.currentTarget).val().toLowerCase();
        $('.list .item').each(function(i,el){
            if($(el).attr('data-ref').indexOf(val) > -1) {
                $(el).fadeIn();
                $(el).next('.messaging').fadeIn();
            }
            else {
                $(el).fadeOut();
                $(el).next('.messaging').fadeOut();
            }

        })
    }

    function changeToFor(val){
        if(val == 'for'){
            $('.to-container').fadeOut(function(){
                $('.for-container').fadeIn();
            });
        }else{
            $('.for-container').fadeOut(function(){
                $('.to-container').fadeIn();
            });
        }
    }

    //--------------------------------------------------------------------------------------------------------
    // Quote Email

    QuoteEmail = function() {
        this.$form;
        this.init();
    }

    QuoteEmail.prototype.init = function(){
        $(document).on('click',"[data-action='clicked']",function(){
            $("[data-action='clicked']").removeAttr('clicked',true);
            $(this).attr('clicked',true);
        });
        $(document).on('click',"[data-action='confirm-email']", $.proxy(this.sendEmail,this));
        $(document).on('submit','.quote-email', $.proxy(this.popup,this));
    }

    QuoteEmail.prototype.popup = function(e){

        var email = $('#'+$('button[clicked="true"]').attr('data-ref')).val();
        if(email != "no-email") {
            this.emailFormat = $('button[clicked="true"]').attr('data-email-format');
            this.$form = $(e.currentTarget);
            $.magnificPopup.open({
                items: {
                    src: '<div class="white-popup">' +
                    '<h4>Email Override</h4>' +
                    '<div class="form-group"><input data-ref="email-override" class="form-control" value="' + email + '"/></div>' +
                    '<div class="form-group form-group-lg form-group-submit"><button data-action="confirm-email" class="btn btn-sc btn-submit btn-block primary-btn">Confirm</button>' +
                    '</div>',
                    type: 'inline'
                }
            });
            return false;
        }
    }

    QuoteEmail.prototype.sendEmail = function(e){
        if(!$(e.currentTarget).attr('disabled')) {
            email = $('[data-ref="email-override"]').val();
            $("[data-action='confirm-email']").html("Sending").attr('disabled', true);
            var serializeData = this.$form.serializeObject();
            serializeData["email"] = email;
            serializeData["format"] = this.emailFormat;
            delete serializeData["self-email"];
            delete serializeData["user-email"];
            delete serializeData["self-email-text"];
            $.post("",serializeData)
                .done(function(data){
                    $('.white-popup .form-group').fadeOut();
                    $('.white-popup h4').html(data);
                })
                .fail(function(){
                    $('.white-popup .form-group').fadeOut();
                    $('.white-popup h4').html("Error sending the email");
                })
                .always(function() {
                    setTimeout($.magnificPopup.close, 5000);
                });
        }
    }

    $.fn.serializeObject = function()
    {
        var o = {};
        var a = this.serializeArray();
        $.each(a, function() {
            if (o[this.name] !== undefined) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            } else {
                o[this.name] = this.value || '';
            }
        });
        return o;
    };

    function nl2br (str, is_xhtml) {
        var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    }

    //-------------------------------------------------------------------
    // Data Copier

    DataCopier = function($el)
    {
        this.$el = $el;
        this.$origin = $(this.$el.data('copy'));

        this.init();
    }

    DataCopier.prototype.init = function()
    {
        this.default = this.$el.data('copy-default');
        if(typeof this.default === 'undefined')
            this.default = "";

        if(typeof this.$el.data('copy-default') !== "undefined")
            this.$el.html(this.default);

        this.option = this.$el.data('copy-option');
        this.$dependant = $(this.$el.data('copy-dependant'));

        if(this.$origin)
            this.$origin.on('change select keyup place_changed dp.change',$.proxy(this.copier,this));
        if(this.$dependant.length)
            this.$dependant.on('change select keyup place_changed dp.change',$.proxy(this.copier,this));

        this.copier();
    }

    DataCopier.prototype.copier = function()
    {
        var val = this.default;
        if(this.option == "html")
        {
            val = this.$origin.find("option[value='"+this.$origin.val()+"']").html();
        }else {
            val = this.$origin.val();
            if (this.option == "yes-no") {
                if (val == 1)
                    val = "Yes";
                else
                    val = "No";
            }
        }

        if(this.$dependant.length && this.$dependant.val() == 0) {
            val = this.default;
        }

        this.$el.html(val);
    }

    DataCopier.init = function()
    {
        $(document).find('[data-copy]').each(function(i,el){
            var datacopier = $(el).data('DataCopier');
            if (!datacopier) {
                datacopier = new DataCopier($(el));
                $(el).data('DataCopier', datacopier);
            }
        });
    };


    PreviewPassword = function (input, btn) {
        this.input = document.getElementById(input);
        this.btn = document.getElementById(btn);
        this.init();
    };

    PreviewPassword.prototype.init = function () {

        document.getElementById('form_email').setAttribute('type', 'password');

        $(this.btn).click(function () {
            if ($(this.input).is(':password')) {
                this.show();
            } else if ($(this.input).is(':text')) {
                this.hide();
            }
        }.bind(this));

    };

    PreviewPassword.prototype.show = function () {
        this.input.setAttribute('type', 'text');
        this.btn.classList.remove('fa-eye');
        this.btn.classList.add('fa-eye-slash');

        if (this.input.classList.contains('fa-eye-slash')) {
            setInterval(function () {
                this.hide();
            }.bind(this), 10000);
        }

    };

    PreviewPassword.prototype.hide = function () {
        this.input.setAttribute('type', 'password');
        this.btn.classList.remove('fa-eye-slash');
        this.btn.classList.add('fa-eye');
    };


})(jQuery);
